module.exports = __webpack_public_path__ + "static/media/appleapp-350.cb8c51c3.png";